var wordpressMessageEnum;
(function (wordpressMessageEnum) {
    wordpressMessageEnum["THANK_YOU_FOR_PARTICIPATING"] = "bedankt-voor-deelname";
    wordpressMessageEnum["NOT_A_PART_OF_TARGET_AUDIENCE"] = "geen-onderdeel-van-doelgroep";
})(wordpressMessageEnum || (wordpressMessageEnum = {}));
export default wordpressMessageEnum;
